import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var MotionPerson = createIcon({
  displayName: 'MotionPerson',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M6.5,9h-4a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.5,6h-4a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M7.5,12h-4a.5.5,0,0,1,0-1h4a.5.5,0,0,1,0,1Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M20,11H17.91l-.81-.81L17.77,9a1,1,0,0,0-.31-1.31L15,6H10.82L8.95,9.36a1,1,0,1,0,1.75,1L12,8h2L9,17H6a1,1,0,0,0,0,2H9.58a1,1,0,0,0,.87-.51l2.21-4L15,16.84V21a1,1,0,0,0,2,0V16.41a1,1,0,0,0-.29-.7L15,14l1.09-2L17,13h3a1,1,0,0,0,0-2Z"
  }), /*#__PURE__*/_jsx("circle", {
    cx: "18",
    cy: "4",
    r: "2"
  })]
});
//# sourceMappingURL=MotionPerson.js.map